import { useBFF } from '~/composables/useBFF/useBFF';

interface Tag {
  name: string;
  displayName: string;
  backgroundColor: string;
  fontColor: string;
  borderColor: string;
  svgIcon: string;
  iconPosition: 'left' | 'right' | 'none';
  showInPdp: boolean;
  showInPlp: boolean;
  tagDisabled: boolean;
  priority: number;
}
const tags = ref<Tag[]>([]);

export const useTagsLoader = () => {
  const { $magnolia } = useBFF();

  const loading = ref(false);

  const fetchTags = async () => {
    loading.value = true;
    try {
      const resp = await $magnolia.fetchMarketingTags();

      tags.value = resp.data as Tag[];
    }
    catch {
      tags.value = [];
    }
    finally {
      loading.value = false;
    }
  };

  return {
    tags: computed(() => tags.value),
    loading: computed(() => loading.value),
    fetchTags,
  };
};
